// SPDX-License-Identifier: AGPL-3.0-or-later

import type {ValueOf} from '@fluxer/constants/src/ValueOf';

export const ConnectionTypes = {
	BLUESKY: 'bsky',
	DOMAIN: 'domain',
	STEAM: 'steam',
	TWITCH: 'twitch',
	KICK: 'kick',
	BATTLENET: 'battlenet',
	YOUTUBE: 'youtube',
} as const;

export type ConnectionType = ValueOf<typeof ConnectionTypes>;

export const OAUTH_CONNECTION_TYPES = [
	ConnectionTypes.STEAM,
	ConnectionTypes.TWITCH,
	ConnectionTypes.KICK,
	ConnectionTypes.BATTLENET,
	ConnectionTypes.YOUTUBE,
] as const;

export type OAuthConnectionType = (typeof OAUTH_CONNECTION_TYPES)[number];

export function isOAuthConnectionType(value: unknown): value is OAuthConnectionType {
	return (OAUTH_CONNECTION_TYPES as ReadonlyArray<unknown>).includes(value);
}
export const ConnectionVisibilityFlags = {
	EVERYONE: 1 << 0,
	FRIENDS: 1 << 1,
	MUTUAL_GUILDS: 1 << 2,
} as const;

export const ConnectionVisibilityFlagsDescriptions: Record<keyof typeof ConnectionVisibilityFlags, string> = {
	EVERYONE: 'Allow anyone to see this connection',
	FRIENDS: 'Allow friends to see this connection',
	MUTUAL_GUILDS: 'Allow members from mutual guilds to see this connection',
};
export const MAX_CONNECTIONS_PER_USER = 20;
export const CONNECTION_VERIFICATION_TOKEN_LENGTH = 32;
export const CONNECTION_INITIATION_TOKEN_EXPIRY_MS = 30 * 60 * 1000;
export const CONNECTION_AUTHORIZATION_STATE_EXPIRY_MS = 10 * 60 * 1000;

// Platforms whose linked accounts can carry a live badge: the server sends only the platform and the login, the client
// builds the channel URL from them.
export const STREAM_ACTIVITY_PLATFORMS = [ConnectionTypes.TWITCH, ConnectionTypes.KICK] as const;
export type StreamActivityPlatform = (typeof STREAM_ACTIVITY_PLATFORMS)[number];
export const STREAM_ACTIVITY_LOGIN_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
